import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ClientService } from 'src/app/services/client.service';
import { ContextService } from 'src/app/services/context.service';

@Component({
	selector: 'app-configure',
	templateUrl: './configure.component.html',
	styleUrls: ['./configure.component.css']
})
export class ConfigureComponent implements OnInit {
	@Output() emitExit = new EventEmitter<any>();
	@Input() folders = [];
	loading = true;

	showHelp = false;

	originalClientDetailProcore: any;
	clientDetailProcore: any;
	projectConfigs: any = {};

	showCommunicationExpanded = false;
	showWorkflowExpanded = false;
	showRequestExpanded = false;
	showStorageExpanded = false;

	folderOptions = [];

	constructor(
		private clientService: ClientService,
		private contextService: ContextService
	) { }

	ngOnInit() {
		this.clientDetailProcore = this.contextService.clientDetailProcore;
		this.originalClientDetailProcore = JSON.parse(JSON.stringify(this.clientDetailProcore));

		for (const folder of this.folders) {
			this.populateFolderOptions(folder, 0);
		}

		this.setProjectConfigs();

		this.loading = false;
	}

	setProjectConfigs() {
		this.setDefaultProjectConfigs();
		for (const config of this.clientDetailProcore.projectConfigs) {
			if (config.configName === 'allowDefaultLocationOverride') {
				this.projectConfigs[config.configName] = config.configValue === 'true';
			} else {
				this.projectConfigs[config.configName] = config.configValue;
			}
		}
	}

	setDefaultProjectConfigs() {
		this.projectConfigs = {
			allowDefaultLocationOverride: false,
			primeContractStorage: 'default',
			primeContractCoStorage: 'default',
			primeContractPcoStorage: 'default',
			subcontractStorage: 'default',
			subcontractCoStorage: 'default',
			subcontractPcoStorage: 'default',
			purchaseOrderStorage: 'default',
			purchaseOrderCoStorage: 'default',
			purchaseOrderPcoStorage: 'default'
		};
	}

	cancelConfigurations() {
		this.contextService.clientDetailProcore = JSON.parse(JSON.stringify(this.originalClientDetailProcore));
		this.clientDetailProcore = JSON.parse(JSON.stringify(this.originalClientDetailProcore));

		this.setProjectConfigs();

		this.emitExit.emit('');
	}

	updateConfigurations() {
		this.loading = true;
		this.clientService.updateClientDetailProcore(this.clientDetailProcore).subscribe(() => {
			this.clientService.updateProcoreProjectConfigs(this.projectConfigs, this.clientDetailProcore.clientId, this.contextService.procoreContextObject.context.project_id)
				.subscribe(() => {
					for (let config of this.clientDetailProcore.projectConfigs) {
						if (config.configName == 'allowDefaultLocationOverride') {
							config.configValue = this.projectConfigs.allowDefaultLocationOverride;
						} else if (config.configName == 'primeContractCoStorage') {
							config.configValue = this.projectConfigs.primeContractCoStorage;
						} else if (config.configName == 'primeContractPcoStorage') {
							config.configValue = this.projectConfigs.primeContractPcoStorage;
						} else if (config.configName == 'primeContractStorage') {
							config.configValue = this.projectConfigs.primeContractStorage;
						} else if (config.configName == 'purchaseOrderCoStorage') {
							config.configValue = this.projectConfigs.purchaseOrderCoStorage;
						} else if (config.configName == 'purchaseOrderPcoStorage') {
							config.configValue = this.projectConfigs.purchaseOrderPcoStorage;
						} else if (config.configName == 'purchaseOrderStorage') {
							config.configValue = this.projectConfigs.purchaseOrderStorage;
						} else if (config.configName == 'subcontractCoStorage') {
							config.configValue = this.projectConfigs.subcontractCoStorage;
						} else if (config.configName == 'subcontractPcoStorage') {
							config.configValue = this.projectConfigs.subcontractPcoStorage;
						} else if (config.configName == 'subcontractStorage') {
							config.configValue = this.projectConfigs.subcontractStorage;
						}
					}
					this.loading = false;
					this.emitExit.emit('');
				});
		});
	}

	populateFolderOptions(folder: any, depth: number) {
		this.folderOptions.push({
			id: folder.id,
			name: '-'.repeat(depth) + folder.name
		});
		if (folder.children) {
			for (const child of folder.children) {
				this.populateFolderOptions(child, depth + 1);
			}
		}
	}
}
